/*
 * -----------------------------------------------------------------------
 *  <copyright file="date-helpers.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2022 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

// Strip JS Date objects of time info, so they can be sent in GraphQL queries requiring Date type (DateGraphType)
// If not used will see "Error: Network error: Response not successful: Received status code 400"
const withoutTime = (dateTime: Date) => {
    const date = new Date(dateTime.getTime());
    date.setHours(0, 0, 0, 0);

    return date;
};

const dateToTimestamp = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${year}-${month}-${day}`;
}

export { withoutTime, dateToTimestamp };
